import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, Row, Col, message, Select } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';
import moment from 'moment';
import usePermissions from '../../hooks/usePermissions';
import SpinLoading from '../../components/MyOrderActions/SpinLoading';

const { Option } = Select;


const PerformanceOverview = ({ handleClose }) => {
    const [loading, setLoading] = useState({
        getDropdown: false,
        formSubmission: false
    });
    const [form] = Form.useForm();
    const [dropDownData, setDropDownList] = useState([])


    const handleFinish = async (values) => {
        setLoading(prev => ({
            ...prev,
            formSubmission: true
        }));
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');
            const location = values.location || '';

            const params = {
                from_date,
                to_date,
                location,
            };


            const response = await axiosInstance.get('/task/v2/performance-sheet/', {
                params,
                responseType: 'blob'
            });


            if (response.status === 200) {
                // ✅ Handle file download
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully")
                handleClose()

                return { success: true };
            } else {
                message.success("Something went wrong")
                setLoading(prev => ({
                    ...prev,
                    formSubmission: false
                }));
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg =
                            errorJson?.message ||
                            errorJson?.detail ||
                            'Something went wrong while downloading the sheet.';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("An unknown error occurred.");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(prev => ({
                ...prev,
                formSubmission: false
            }));
        }
    };

    const fetchDropdownList = async () => {
        setLoading(prev => ({
            ...prev,
            getDropdown: true
        }));
        try {
            const res = await axiosInstance.get("/task/v2/performance-sheet-locations/")

            if (res.status === 200) {
                setDropDownList(res.data.data || [])
                setLoading(prev => ({
                    ...prev,
                    getDropdown: false
                }));
            }

        } catch (err) {
            console.log(err)
            setLoading(prev => ({
                ...prev,
                getDropdown: false
            }));
        }
    }

    useEffect(() => {
        fetchDropdownList()
    }, [])

    if (loading.getDropdown) {
        return <SpinLoading tip="Loading status options..." style={{ display: 'block', marginTop: '0' }} />;
    }


    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
        >
            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>

            </Row>
            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Location"
                        name="location"
                        rules={[{ required: true, message: 'Please select a location' }]}
                    >
                        <Select
                            placeholder="Select a Location"
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {dropDownData.map((member) => (
                                <Option key={member.uid} value={member.uid} label={member.location}>
                                    {member.location}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading.formSubmission}>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default PerformanceOverview;